export default "__VITE_ASSET__BJcB8539__"